import PropTypes from 'prop-types';

import {
  PROPERTY_MANAGEMENT_SOFTWARE_NAME_RENT_MANAGER,
  PROPERTY_MANAGEMENT_SOFTWARE_NAME_RENTVINE,
} from 'common/propertyManagementSoftwareConstants';

export const UTILITY_CONFIGURATION_SOURCE_DEFAULT = 'default';
export const UTILITY_CONFIGURATION_SOURCE_ADMIN = 'admin';
export const UTILITY_CONFIGURATION_SOURCE_PARTNER = 'partner';
export const UTILITY_CONFIGURATION_SOURCE_RENTVINE = 'rentvine';
export const UTILITY_CONFIGURATION_SOURCE_RENT_MANAGER = 'rentManager';

export const UTILITY_CONFIGURATION_SOURCES = [
  UTILITY_CONFIGURATION_SOURCE_DEFAULT,
  UTILITY_CONFIGURATION_SOURCE_ADMIN,
  UTILITY_CONFIGURATION_SOURCE_PARTNER,
  UTILITY_CONFIGURATION_SOURCE_RENTVINE,
  UTILITY_CONFIGURATION_SOURCE_RENT_MANAGER,
];

const UTILITY_CONFIGURATION_PERSON_SOURCES = [
  UTILITY_CONFIGURATION_SOURCE_ADMIN,
  UTILITY_CONFIGURATION_SOURCE_PARTNER,
];

const UTILITY_CONFIGURATION_PMS_SOURCES = [
  UTILITY_CONFIGURATION_SOURCE_RENTVINE,
  UTILITY_CONFIGURATION_SOURCE_RENT_MANAGER,
];

const UTILITY_CONFIGURATION_SOURCE_DISPLAY_NAME_BY_SOURCE = {
  [UTILITY_CONFIGURATION_SOURCE_DEFAULT]: 'Partner defaults',
  [UTILITY_CONFIGURATION_SOURCE_ADMIN]: 'Utility Profit',
  [UTILITY_CONFIGURATION_SOURCE_PARTNER]: 'Partner',
  [UTILITY_CONFIGURATION_SOURCE_RENTVINE]: PROPERTY_MANAGEMENT_SOFTWARE_NAME_RENTVINE,
  [UTILITY_CONFIGURATION_SOURCE_RENT_MANAGER]: PROPERTY_MANAGEMENT_SOFTWARE_NAME_RENT_MANAGER,
};

export const getUtilityConfigurationSourceDisplayName = (source) =>
  UTILITY_CONFIGURATION_SOURCE_DISPLAY_NAME_BY_SOURCE[source] || null;

export const isUtilityConfigurationPersonSource = (source) =>
  UTILITY_CONFIGURATION_PERSON_SOURCES.includes(source);

export const isUtilityConfigurationPmsSource = (source) =>
  UTILITY_CONFIGURATION_PMS_SOURCES.includes(source);

export const utilityConfigurationProvenancePropType = PropTypes.shape({
  source: PropTypes.oneOf(UTILITY_CONFIGURATION_SOURCES).isRequired,
  updatedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
});
